import { useState } from "react";
import Panel from "./Panel";
import Grid from "./Grid";
import DeleteButton from "./DeleteButton";
import { useDeleteQuery } from "../hooks";
import { useUserContext, useDataContext } from "../contexts";
import ConfirmationModal from "./ConfirmationModal";
import Actions from "./Actions";
import { ADMIN, MEMBER } from "../constants";

export default function UserCRUD() {
  const { user: currentUser } = useUserContext();
  const { adminUsers, memberUsers } = useDataContext();

  const deleteAdmin = useDeleteQuery("users/admins");
  const deleteMember = useDeleteQuery("users/members");

  const [deleteModalId, setDeleteModalId] = useState(null);
  const [deleteUserType, setDeleteUserType] = useState(null);

  const allUsers = [...adminUsers, ...memberUsers].sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  function handleDelete(userId, userType) {
    setDeleteModalId(userId);
    setDeleteUserType(userType);
  }

  function confirmDelete() {
    if (deleteUserType === ADMIN) {
      deleteAdmin.mutate(deleteModalId);
    } else {
      deleteMember.mutate(deleteModalId);
    }
    setDeleteModalId(null);
    setDeleteUserType(null);
  }

  return (
    <Panel left="Family Members">
      <Grid
        data={allUsers}
        columnsTemplate="justify-between grid-cols-[auto_auto_auto_auto]"
        renderTestId={(user) => `User ${user.name}`}
        columns={[
          {
            header: "Name",
            render: (user) => (
              <span>
                {user.name}
                {user.id === currentUser.id && (
                  <span className="ml-1 text-gray-500 italic"> (you)</span>
                )}
              </span>
            ),
          },
          {
            header: "Role",
            render: (user) => (
              <span>{user.profileType === ADMIN ? "Admin" : "Member"}</span>
            ),
          },
          {
            header: "Reward",
            render: (user) => (
              <span>
                {user.profileType === MEMBER ? user.responsibilityReward : "-"}
              </span>
            ),
          },
          {
            header: "Actions",
            render: (user) => (
              <Actions>
                <DeleteButton
                  key="delete"
                  onClick={() => handleDelete(user.id, user.profileType)}
                />
              </Actions>
            ),
          },
        ]}
      />
      <ConfirmationModal
        isOpen={deleteModalId !== null}
        onClose={() => {
          setDeleteModalId(null);
          setDeleteUserType(null);
        }}
        heading={`Delete ${deleteUserType === ADMIN ? "Admin" : "Member"}`}
        message={`Are you sure you want to remove this ${
          deleteUserType === ADMIN ? "admin" : "member"
        }?`}
        confirmLabel="Delete"
        onConfirm={confirmDelete}
      />
    </Panel>
  );
}
